import { useSlate } from 'slate-react';

const useEditorTheme = () => {
    const editor = useSlate();

    return editor.children[0].theme || {};
};

export default useEditorTheme;
